<template>
	<sf-data-table
		ref="grpTable"
		index
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:span-method="spanMethod"
		:stripe="false"
		:selection="false"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcmRegn/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdList1;
		},
		cols() {
			return this.dayCols1_;
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 1) {
				if (rowIndex === 0) {
					return {
						rowspan: 1,
						colspan: 1
					};
				} else if (rowIndex == 1) {
					return {
						rowspan: 3,
						colspan: 1
					};
				} else if (rowIndex == 2 || rowIndex == 3) {
					return {
						rowspan: 0,
						colspan: 0
					};
				} else {
					return {
						rowspan: 1,
						colspan: 1
					};
				}
			}
		}
	}
};
</script>

<style></style>
